const state = {
  internal_user: [],
  internal_user_id: [],
  internal_user_header: [],
  role: [],
};

export default state;
